export default __webpack_public_path__ + "static/media/c349b0db03e7d68812ed7f59f9fa545c1599578415983.1fbefda2.webp";